// DS: TA0.4
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useTranslation } from 'react-i18next';
import UserAvatar from '../Avatar/UserAvatar';
import UserLink from '../Link/UserLink';
import DeviationDumbView from '../../DeviationViews/Dumbo/MinimalDumbo';
import ProfileOwnerWatchButton from '../../Button/ProfileOwnerWatchButton';
import DeviationLink from '../../Duperbrowse/DeviationLink';
import { getInfoToDisplayImageDeviation } from '../../DeviationViews/Dumbo/Image/_helpers';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { useVerification } from '../../VerificationPopup/withVerification';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import MonetizationPromoStrip from './MonetizationPromoStrip';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './UserAvatarPopoverContent.scss';
const getBackgroundUrl = (deviation)=>{
    const info = getInfoToDisplayImageDeviation({
        deviation,
        width: parseInt(s['background-picture-width'])
    });
    if (info) {
        return info.pickedImage.src;
    }
};
export const UserAvatarPopoverContent = ({ user, showMonetizationPromo, deviationsCount = 0, featuredDeviations: deviations, withButtons, relatedItemBiData })=>{
    var _user_profile;
    const complete_theme = useFlag('complete_theme');
    const { showBlocked } = useDeviationMatureFilter(user === null || user === void 0 ? void 0 : (_user_profile = user.profile) === null || _user_profile === void 0 ? void 0 : _user_profile.profilePic);
    const { isVerificationNeeded, pushVerificationPopup } = useVerification();
    const { t } = useTranslation();
    if (!user) {
        return null;
    }
    const { username, profile, stats } = user;
    const watchersCount = stats && stats.watchers || 0;
    const deviationStyle = {};
    const deviationClassNames = [];
    let backgroundImageSrc;
    if (profile === null || profile === void 0 ? void 0 : profile.profilePic) {
        backgroundImageSrc = getBackgroundUrl(profile.profilePic);
    }
    if (backgroundImageSrc) {
        deviationStyle.backgroundImage = `url('${backgroundImageSrc}')`;
    } else {
        deviationClassNames.push(s['no-image']);
    }
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: complete_theme ? 'match' : ThemeOptions.LIGHT
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content-with-background'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content-background'], showBlocked && s['mature-blur'], deviationClassNames),
        style: deviationStyle
    }), showMonetizationPromo && /*#__PURE__*/ React.createElement(MonetizationPromoStrip, {
        monetizationPromo: showMonetizationPromo
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content-info'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content-with-mask']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: user,
        size: 50
    }), /*#__PURE__*/ React.createElement(UserLink, {
        className: s['username'],
        user: user
    }), profile && profile.tagline && /*#__PURE__*/ React.createElement("div", {
        className: s['tagline']
    }, profile.tagline), /*#__PURE__*/ React.createElement("div", {
        className: s['stats']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['stat-item']
    }, t('avatar.deviations', {
        formattedCount: shortenNumber(deviationsCount),
        count: deviationsCount
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['stat-item']
    }, ' | '), /*#__PURE__*/ React.createElement("div", {
        className: s['stat-item']
    }, t('avatar.watchers', {
        formattedCount: shortenNumber(watchersCount),
        count: watchersCount
    })))))), /*#__PURE__*/ React.createElement("div", {
        className: s['featured-buttons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['deviations']
    }, deviations && deviations.length > 0 && deviations.slice(0, 4).map((deviation)=>/*#__PURE__*/ React.createElement(DeviationLink, {
            key: deviation.deviationId,
            deviation: deviation,
            title: deviation.title,
            className: s['deviation-item']
        }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
            width: parseInt(s['deviation-item-width']),
            height: parseInt(s['deviation-item-height']),
            deviation: deviation
        }))), /*#__PURE__*/ React.createElement(BiLink, {
        href: Url.userGalleryLink({
            username,
            gallectionType: 'gallery'
        }),
        className: s['see-all-link'],
        biData: BiData({
            evid: 106,
            typeid: undefined,
            itemid: undefined,
            creatorid: user.useridUuid
        })
    }, t('avatar.seeAll'))), withButtons && /*#__PURE__*/ React.createElement("div", {
        className: s['buttons-block']
    }, /*#__PURE__*/ React.createElement(GhostButton, {
        size: "large",
        variant: "main",
        className: classnames(s['button-message'], s['button-item']),
        href: !isVerificationNeeded ? Url.userNoteLink(username) : undefined,
        onClick: isVerificationNeeded ? ()=>pushVerificationPopup('notes') : undefined,
        biData: BiData({
            evid: 273,
            typeid: relatedItemBiData === null || relatedItemBiData === void 0 ? void 0 : relatedItemBiData.typeid,
            itemid: relatedItemBiData === null || relatedItemBiData === void 0 ? void 0 : relatedItemBiData.itemid,
            friend_id: user.useridUuid
        })
    }, t('avatar.message')), /*#__PURE__*/ React.createElement(ProfileOwnerWatchButton, {
        user: user,
        initialData: {
            isWatching: !!user.isWatching,
            isLoading: false
        },
        className: s['button-item']
    })))));
};
export default UserAvatarPopoverContent;
